var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKreski(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 32,
    viewBox: "0 0 375 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0E2B63",
    d: "M0 32L127 32 127 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004F9F",
    d: "M127 32L211 32 211 0 127 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B6E5",
    d: "M211 32L258 32 258 0 211 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8D03",
    d: "M258 32L294 32 294 0 258 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBA00",
    d: "M294 32L314 32 314 0 294 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50AF47",
    d: "M314 32L333 32 333 0 314 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFCA0B",
    d: "M333 32L350 32 350 0 333 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A328A",
    d: "M350 32L363 32 363 0 350 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E72582",
    d: "M363 32L375 32 375 0 363 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreski);
export default __webpack_public_path__ + "static/media/kreski.1538992a7a4e103d9ebf9b78d6b455b4.svg";
export { ForwardRef as ReactComponent };